import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import "../../style/about.css";

function About() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-hero-title">
            About <span className="about-hero-brand">KG</span>
          </h1>
          <p className="about-hero-subtitle">
            Bringing authentic Japanese culinary traditions to New Zealand
          </p>
        </div>
      </div>

      {/* Story Section */}
      <div className="about-section">
        <div className="about-container">
          <h2 className="about-section-title">Our Story</h2>
          <div className="about-divider"></div>
          
          <div className="about-story">
            <p>
              We embarked on our journey with a passion to introduce the rich heritage of 
              Japanese donburi and extend the vibrant tapestry of Japanese culinary 
              traditions to the community of New Zealand.
            </p>
            
            <p>
              Our dedicated team eagerly awaits the opportunity to greet you at our 
              restaurant, where we aspire to cultivate an environment of serenity and 
              warmth for all our guests.
            </p>
          </div>
        </div>
      </div>

      {/* Values Section */}
      <div className="about-values-section">
        <div className="about-container">
          <h2 className="about-section-title">Our Values</h2>
          <p className="about-section-subtitle">
            The principles that guide everything we do at KG
          </p>

          <div className="about-values-grid">
            {/* Value 1 */}
            <div className="about-value-card">
              <div className="about-value-icon">
                <RestaurantIcon />
              </div>
              <h3 className="about-value-title">Authenticity</h3>
              <p className="about-value-description">
                Traditional Japanese recipes prepared with genuine techniques and respect for heritage
              </p>
            </div>

            {/* Value 2 */}
            <div className="about-value-card">
              <div className="about-value-icon">
                <span className="about-value-emoji">❤️</span>
              </div>
              <h3 className="about-value-title">Hospitality</h3>
              <p className="about-value-description">
                Creating a warm, welcoming environment where every guest feels like family
              </p>
            </div>

            {/* Value 3 */}
            <div className="about-value-card">
              <div className="about-value-icon">
                <span className="about-value-emoji">🌟</span>
              </div>
              <h3 className="about-value-title">Quality</h3>
              <p className="about-value-description">
                Using only the finest ingredients to deliver exceptional dining experiences
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="about-section">
        <div className="about-container">
          <h2 className="about-section-title">Visit Us</h2>
          <p className="about-section-subtitle">
            We'd love to welcome you to our restaurant
          </p>

          <div className="about-contact-grid">
            {/* Contact Info */}
            <div className="about-contact-info">
              <div className="about-contact-item">
                <div className="about-contact-icon">
                  <PhoneIcon />
                </div>
                <div>
                  <h3 className="about-contact-label">Phone</h3>
                  <a href="tel:6493078080" className="about-contact-link">
                    09 307 8080
                  </a>
                </div>
              </div>

              <div className="about-contact-item">
                <div className="about-contact-icon">
                  <LocationOnIcon />
                </div>
                <div>
                  <h3 className="about-contact-label">Location</h3>
                  <p className="about-contact-text">
                    211 Parnell Road, Parnell, Auckland 1052
                  </p>
                </div>
              </div>

              <div className="about-contact-item">
                <div className="about-contact-icon">
                  <InstagramIcon />
                </div>
                <div>
                  <h3 className="about-contact-label">Follow Us</h3>
                  <a
                    href="https://www.instagram.com/kg_jp_restaurant/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="about-contact-link"
                  >
                    @kg_jp_restaurant
                  </a>
                </div>
              </div>
            </div>

            {/* Opening Hours */}
            <div className="about-hours">
              <h3 className="about-hours-title">Opening Hours</h3>
              <h3 className="about-hours-title">Lunch</h3>
              <div className="about-hours-item">
               
                <span>Monday - Saturday</span>
                <span>11:45 AM - 3:00PM</span>
           
                {/* <span>Friday</span>
                <span>11:45 AM - 3:00PM then 5:00 PM - 12:00 AM(Midnight)</span> */}
              </div>
              <h3 className="about-hours-title">Dinner</h3>
              <div className="about-hours-item">
                <span>Monday - Thursday</span>
                <span>5:00 PM - 8:30 PM</span>
              </div>
              <div className="about-hours-item">
                <span>Friday </span>
                <span>5:00 PM - 12:00 AM (Midnight)</span>
              </div>
              <div className="about-hours-item">
                <span>Saturday</span>
                <span>5:00 PM - 8:30 PM</span>
              </div>
              <br></br>
              <div className="about-hours-item">
                <span><b>Sunday</b></span>
                <span><b>CLOSED</b></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="about-cta">
        <div className="about-cta-content">
          <h2 className="about-cta-title">
            Experience Authentic Japanese Cuisine
          </h2>
          <p className="about-cta-subtitle">
            Visit us today and taste the difference tradition makes
          </p>
          <div className="about-cta-buttons">
            <a href="tel:6493078080" className="about-cta-btn about-cta-btn-primary">
              <PhoneIcon />
              Call Now
            </a>
            <a
              href="https://www.instagram.com/kg_jp_restaurant/"
              target="_blank"
              rel="noopener noreferrer"
              className="about-cta-btn about-cta-btn-secondary"
            >
              <InstagramIcon />
              Follow Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
